<template>
  <div class="tender-information">
    <TenderGeneralInformation :tender="tender" />
    <TenderEmitterInformation :emitter="tender.emitter" />
  </div>
</template>

<script>
import TenderEmitterInformation from '@/components/page-tender-details/TenderEmitterInformation';
import TenderGeneralInformation from '@/components/page-tender-details/TenderGeneralInformation';

export default {
  name: 'TenderInformation',
  components: {
    TenderEmitterInformation,
    TenderGeneralInformation,
  },
  props: {
    tender: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
.tender-information {
  display: flex;
  flex-direction: row;
  padding: 2rem;
  gap: 32px;
  background: $color-white;
  border-radius: $border-radius-root;
  width: 100%;

  @media screen and (max-width: 784px) {
    flex-direction: column;
  }
}
</style>
